import { jsx as _jsx } from "react/jsx-runtime";
import { useFormContext } from 'react-hook-form';
import { Size } from '@jetbrains/ring-ui/components/input/input';
import RegisteredInput from '@app/common/hook-form/registered-input';
function ValueField({ settingIndex }) {
    const { control } = useFormContext();
    return (_jsx(RegisteredInput, { label: "Value", size: Size.L, name: `content.${settingIndex}.value`, control: control }));
}
export default ValueField;
